import { Asset, SharingLink } from '../../api';

export type GoogleBulkState = {
  inProgress: Partial<Record<string, true>>;
  progressValues: Partial<Record<string, number>>;
  links: Partial<Record<string, string>>;
};

export enum GoogleBulkMode {
  assets = 'assets',
  pack = 'pack',
  sharingAll = 'sharingAll',
}

export type GoogleBulkParams =
  | {
      mode: GoogleBulkMode.assets;
      assetIds: Asset['id'][];
      sharingId: SharingLink['id'] | undefined;
    }
  | { mode: GoogleBulkMode.pack }
  | { mode: GoogleBulkMode.sharingAll; sharingId: SharingLink['id'] | undefined };

export function createHash(params: GoogleBulkParams): string {
  if (params.mode === GoogleBulkMode.pack) {
    return params.mode;
  }
  if (params.mode === GoogleBulkMode.sharingAll) {
    return `${params.mode}_${params.sharingId ?? ''}`;
  }
  if (params.mode === GoogleBulkMode.assets) {
    return `${params.mode}_${[...params.assetIds].sort().join(',')}`;
  }
  return '';
}
